module.exports = __webpack_public_path__ + "media/brand/yoojo-logo-icon@white-74117aa2.svg";